import React from "react";

export default function NoneLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
